import request from '@/utils/http'
import { decodeUrl } from '@/utils/urlMapper'
// 获取海报信息
export const getPosterList = () => {
  return request({
    url: decodeUrl('posterList'),
    method: 'get'
  })
}

// 获取书籍分类信息
export const getCategoryList = (params = {}) => {
  return request({
    url: decodeUrl('categoryList'),
    method: 'get',
    params
  })
}

// 获取书籍分类配置信息（根据分类返回推荐书籍 + 作者影片）
export const getBookCategoryConfig = (params = {}) => {
  return request({
    url: decodeUrl('bookCategoryConfig'),
    method: 'get',
    params
  })
}

// 获取首页统计数据（出版物 / 作者 / 下载量）
export const getStatistics = () => {
  return request({
    url: decodeUrl('statistics'),
    method: 'get'
  })
}